export default __webpack_public_path__ + "static/media/authorize.b33a9388.svg";